import React from 'react';
import BlockContent from '@sanity/block-content-to-react';

import Annotation from '@components/Annotation';
import colors from '@utils/colors';

const TEXT_COLORS = {
  blue: colors.B500,
  green: colors.G500,
  orange: colors.O500,
  purple: colors.P500,
};

const colorMark = (color) => ({ children }) => (
  <span style={{ color: TEXT_COLORS[color] }}>{children}</span>
);

const serializers  = {
  types: {
    block: (props) => {
      const {style = 'normal'} = props.node;

      const heading = style.match(/^(h\d)(?:-(center|right))?$/);

      if (heading) {
        const nameKey = props.children.length &&
                        typeof props.children[0].replace !== 'undefined' ?
                          props.children[0].replace(/\W/g, '-').toLowerCase() : '';
        const hashUrl = typeof window !== 'undefined' ?
          `${window.location.origin}${window.location.pathname}#${nameKey}` : '';
        const headerProps = {
          id: nameKey,
          onClick: () => navigator.clipboard.writeText(hashUrl),
          ...(heading[2] && { style: { textAlign: heading[2] } }),
        };

        return React.createElement(heading[1], headerProps, props.children);
      }

      return BlockContent.defaultSerializers.types.block(props);
    },
  },
  marks: {
    blue: colorMark('blue'),
    green: colorMark('green'),
    orange: colorMark('orange'),
    purple: colorMark('purple'),
    annotation: (props) => {
      return (
        <Annotation annotation={props.mark.text}>{props.children}</Annotation>
      );
    },
    link: ({ mark, children }) => {
      const { blank, href } = mark;
      return blank ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={href}>{children}</a>
      );
    },
  },
};

function Block({ content }) {
  return <BlockContent blocks={content} serializers={serializers} />;
}

export default Block;
